export function readCurrentHash(): string {
    return typeof window === "undefined" ? "" : window.location.hash;
}

export function restoreAuthHash(hash: string): void {
    if (typeof window === "undefined" || window.location.hash === hash) return;
    window.history.replaceState(
        window.history.state,
        "",
        `${window.location.pathname}${window.location.search}${hash}`,
    );
}
